import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { EmailTypes } from 'types/Appointment';
import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type Appointment = {
  ID: number;
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: Maybe<string>;
  integrationId: number;
  freightTrackingId: string;
  loadId: number;
  tmsCustomerId: Maybe<string>;
  customerName: string;
  ExternalID: string;
  ConfirmationNo: string;
  ExternalPrivateID: number;
  ExternalWarehouseID: string;
  WarehouseID: number;
  LoadTypeID: string;
  DockID: string;
  Date: string;
  TimePreference: string;
  PONums: string;
  RefNumber: string;
  CcEmails: Maybe<string[]>;
  StartTime: string;
  Notes: string;
  Source: string;
  Status: string;
  EmailTemplateID: number;
  EmailBody: string;
  tenant: string;
  stopType: string;
  EmailType: EmailTypes;
};

export type GetAppointmentsResponse = {
  appointments: Appointment[];
};

export async function getAppointments(
  freightTrackingID: string
): Promise<Result<GetAppointmentsResponse, ApiError>> {
  try {
    const response = await axios.get<GetAppointmentsResponse>(
      `/appt?freightTrackingID=${encodeURIComponent(freightTrackingID)}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getAppointments' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get appointments' });
    }

    return err({
      message: error.response?.data.message || 'Failed to get appointments',
    });
  }
}
